import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const InfoNavigation = (props) => {
  const { currencyCode, stayLength, labelStyles, currencyCodeStyles, stayLengthStyles } = props;
  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const styles = { ...style };
  styles.textAlignLast = 'center';
  return (
    <Box className={className} style={style}>
      <Text paddingRight="1" floatLeft {...labelStyles}>
        {translate('cmp-hotels-low-rates-info', 'Lowest avg rates in')}
      </Text>
      {currencyCode && (
        <Text dataTestId="info-panel-currency" paddingRight="1" {...currencyCodeStyles}>
          ({currencyCode})
        </Text>
      )}
      /
      <Text dataTestId="info-panel-nights" paddingLeft="1" {...stayLengthStyles}>
        {stayLength}
      </Text>
    </Box>
  );
};

InfoNavigation.propTypes = {
  currencyCode: PropTypes.string,
  stayLength: PropTypes.string
};
InfoNavigation.defaultProps = {
  currencyCode: 'USD',
  stayLength: 'any stay length'
};
InfoNavigation.componentName = 'InfoNavigation';

export default InfoNavigation;
